export default "__VITE_ASSET__BXM3J5e0__"